import { tv } from '~/utils/tv'

export const SwitchRootVariants = tv({
  base: `
    flex flex-row gap-twopulse p-twopulse items-center
  `,
  variants: {},
})
